import React from "react";

const GlobalAccordion = ({ data, isFullWidth, idPrefix, headingLevel = 3 }) => { // Add idPrefix prop
  // Accordion items always sit underneath a section heading, so they default to
  // h3. Bootstrap's example markup uses h2, which made every item a sibling of
  // the section it belongs to rather than a child of it. Purely semantic:
  // .accordion-button pins its own font-size, so the rank changes nothing
  // visually. Pass headingLevel to override where the nesting differs.
  const Heading = `h${headingLevel}`;

  return (
    <div className="container">
      <div className={`row g-5 align-items-center `}>
        <div
          className={`  ${
            isFullWidth ? "offset-lg-1 col-lg-10 " : "unified_padding"
          } `}
        >
          <div className="rbt-accordion-style accordion">
            <div className="rbt-accordion-style rbt-accordion-04 accordion">
              <div className="accordion" id={`accordionExample-${idPrefix}`}> {/* Use idPrefix here */}
                {data?.map((item, index) => (
                  <div className="accordion-item card" key={index}>
                    <Heading
                      className="accordion-header card-header"
                      id={`heading-${idPrefix}-${index}`} // Use idPrefix here
                    >
                      <button
                        className={`accordion-button ${
                          index !== 0 ? "collapsed" : ""
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${idPrefix}-${index}`} // Use idPrefix here
                        aria-expanded={index === 0}
                        aria-controls={`collapse-${idPrefix}-${index}`} // Use idPrefix here
                      >
                        {item.title}
                      </button>
                    </Heading>
                    <div
                      id={`collapse-${idPrefix}-${index}`} // Use idPrefix here
                      className={`accordion-collapse collapse ${
                        index === 0 ? "show" : ""
                      }`}
                      aria-labelledby={`heading-${idPrefix}-${index}`} // Use idPrefix here
                      data-bs-parent={`#accordionExample-${idPrefix}`} // Use idPrefix here
                    >
                      <div className="accordion-body card-body">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `
        <style>
          p {
            margin: 0 !important;
            padding: 0 !important;
            line-height: inherit !important;
          }
        </style>
        ${item.discription ?? item?.description}
      `,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalAccordion;